import { render, staticRenderFns } from "./cert_count.vue?vue&type=template&id=c23da978&scoped=true"
import script from "./cert_count.vue?vue&type=script&lang=js"
export * from "./cert_count.vue?vue&type=script&lang=js"
import style0 from "./cert_count.vue?vue&type=style&index=0&id=c23da978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23da978",
  null
  
)

export default component.exports